import './../css/_app.scss'
// import pageTransitions from './animations/transitions';
// import * as basicScroll from 'basicscroll'
import utils from './utils';
import nav from './nav';
import form from './form';
import {sliders, timelineSlider } from './sliders';
import './menu';
import accordion from'./accordion';
import './loadmore';
import './search';
import accesibility from './accesibility';
import './public';
// import './security';
import searchFiles from './search-files';
import './tabs';
import '@popperjs/core/dist/umd/popper';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import 'simplebar';
import 'simplebar/dist/simplebar.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import sectionTracker from './sectionTracker';

export default class App {
	constructor() {
		this.initDev(); // tests and shit
		this.initBody(); // runs on initialize & after barba
	}

	initBody() {
		sliders();
		timelineSlider();
		form();
		accordion();
		searchFiles.init();
		AOS.init({
			disable: 'mobile',
			once: true,
			duration: 1000
		});
		sectionTracker.init();

	}

	initCore() {
		// pageTransitions(); // barbaajs
		nav.emptyLink();
		accesibility();
	}

	initDev() {
		utils.clone('[data-clone]');
	}
}


function LoadApp() {
	const app = new App();
	app.initCore(); // runs on initialize
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', LoadApp);
} else {
	LoadApp();
}